export class UserInfo {
    public static Language: number = 2;
    public static UserID: string = '';
    public static UserName: string = '';
    public static CurrentSalesmanNo: string = '';//'LOSV0001';
    public static UserCode: string = '';//'LOSV0001';
    public static BUID: string = '';
    public static BusinessUnitName: string = '';
    public static BusinessUnitAName: string = '';
	  public static BrowserType: number = 1;   
    public static AccessToken: string = '';
    public static refreshToken: string = '';
    public static FWToken: string = '';
    public static ODataToken: string = '';
    public static BOToken: string = '';
    public static Claims: any = null;
    public static Password: string = '';
    public static AuthType: string = '';

  
}
